import { useState } from 'react';
import { type OptinConfig, OptinType } from '@/services/queueApi.service';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface OptinCheckboxProps {
  optin: OptinConfig;
  checked: boolean;
  onChange: (checked: boolean) => void;
  textColor: string;
}

export function OptinCheckbox({ optin, checked, onChange, textColor }: OptinCheckboxProps) {
  const [showContentDialog, setShowContentDialog] = useState(false);

  return (
    <>
      <label className="flex items-start gap-2" style={{ color: textColor }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1"
        />
        <span className="text-sm">
          {optin.label}
          {optin.type === OptinType.TEXT && optin.content && (
            <>
              {' '}
              <button
                type="button"
                onClick={() => setShowContentDialog(true)}
                className="underline hover:opacity-80"
                style={{ color: textColor }}
              >
                ver termos
              </button>
            </>
          )}
          {optin.type === OptinType.LINK && optin.url && (
            <>
              {' '}
              <a
                href={optin.url}
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:opacity-80"
                style={{ color: textColor }}
              >
                ver detalhes
              </a>
            </>
          )}
          {optin.type === OptinType.DOCUMENT && optin.documentUrl && (
            <>
              {' '}
              <a
                href={optin.documentUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:opacity-80"
                style={{ color: textColor }}
              >
                {optin.documentName || 'ver documento'}
              </a>
            </>
          )}
        </span>
      </label>

      {optin.type === OptinType.TEXT && optin.content && (
        <Dialog open={showContentDialog} onOpenChange={setShowContentDialog}>
          <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>{optin.label}</DialogTitle>
            </DialogHeader>
            <div className="whitespace-pre-wrap text-sm mt-4">
              {optin.content}
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
